import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LocatioInformation, SystemInformation } from '../models/system.model';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  private systemSubject: BehaviorSubject<SystemInformation>;
  public system: Observable<SystemInformation>;

  constructor(
    private httpClient: HttpClient
  ) {
    this.systemSubject = new BehaviorSubject<SystemInformation>({});
    this.system = this.systemSubject.asObservable();
  }

  async GetSystemInformations(): Promise<void> {
    const location = await this.GetInformation();
    const geolocation = await this.GetGeolocation();
    const systemInformacion: SystemInformation = {
      date: new Date().toString(),
      browser: window.navigator.userAgent,
      application: 'FBSBancaWeb',
      geolocation,
      location
    };
    this.systemSubject.next(systemInformacion);
  }

  get systemInfo(): Observable<SystemInformation> {
    return this.system;
  }

  GetGeolocation(): Promise<any> {
    return new Promise((resolve, reject) => {
      window.navigator.geolocation.getCurrentPosition(
        (resp) => {
          resolve({ longitude: resp.coords.longitude.toString(), latitude: resp.coords.latitude.toString() });
        },
        err => {
          resolve({ longitude: 'NO_DETERMINADA', latitude: 'NO_DETERMINADA' });
        }
      );
    });
  }

  async GetInformation(): Promise<LocatioInformation> {
    return await this.httpClient
      .get('http://ip-api.com/json')
      .toPromise()
      .then((resp: any) => {
        const response: LocatioInformation = {
          country: resp.country,
          ip: resp.query
        };
        return response;
      },
        err => {
          return { country: 'NO_DETERMINADA', ip: 'NO_DETERMINADA' };
        });
  }
}
